export function determineActiveIndex(pathname = "") {
  const path = pathname.toLowerCase();
  if (path.startsWith("/purchase")) return 2;
  if (path.startsWith("/challenge")) return 3;
  if (path.startsWith("/trade")) return 4;
  if (path.startsWith("/calculator")) return 5;
  if (path.startsWith("/transaction")) return 6;
  if (path.startsWith("/invite")) return 8;
  if (path.startsWith("/discount")) return 9;
  if (path.startsWith("/certificate")) return 10;
  if (path.startsWith("/profile")) return 12;
  if (path.startsWith("/notification")) return 13;
  if (path.startsWith("/support")) return 14;
  if (path.startsWith("/rule")) return 15;
  return 1;
}

export function shouldUseMiniAside(pathname = "") {
  return /^\/trade\/[^/]+\/trade(?:\/|$)/i.test(pathname);
}
